export default __webpack_public_path__ + "static/media/logo.caa32aa1.png";